import { REMOTE_API_BASE_URL } from '@/app/_constants/urls'
import { IS_ON_SERVER, getServiceUrl } from '@/app/_utils/select-api-service'

import { setUrlParams } from '../../_utils/set-url-params'
import { PLPPages, PLPSlug } from '../types'

export async function getPLPBasicMetas(page: PLPPages, slug: PLPSlug, isServerSideRequest = false) {
    const ntlBaseUrl = getServiceUrl('ntl')
    const cmlBaseUrl = getServiceUrl('cml')

    let url = IS_ON_SERVER && isServerSideRequest ? (REMOTE_API_BASE_URL ?? '') : ''
    if (page === PLPPages.Tags) {
        url += `${cmlBaseUrl}/tags/slug/${slug}`
    } else if (page === PLPPages.Facets) {
        url += `${cmlBaseUrl}/combinations/slug/${slug}`
    } else if (page === PLPPages.BrandCategoriesCombination) {
        url += `${cmlBaseUrl}/combinations/type/CategoryBrand/slug/${slug}`
    } else {
        url += `${ntlBaseUrl}/catalog/${page}/slug/${slug}`
    }

    const finalUrl = setUrlParams(url)

    try {
        const response = await fetch(finalUrl, { cache: 'no-cache' })

        const result = await response.json()

        if (!response.ok) {
            if (result.errors[0].code === 'entity.not.found' || result.errors[0].code === 'record.not.found') {
                return null
            } else {
                throw new Error(`Search for ${finalUrl} failed. Status Code: ${response.status}`)
            }
        }

        return result?.data
    } catch (error) {
        throw new Error(`Error fetching basic metas. URL: ${finalUrl} - ${error}`)
    }
}
